import { useState } from "react";
import "./RevolutionEmail.css";
import { FaTimes } from "react-icons/fa";

export default function RevolutionEmail({ onClose, onConfirm, popupMSG }) {
  const [showPopup, setShowPopup] = useState(true);

  return (
    <>
      <div className="email_popup_overlay">
        <div className="email_popup_container">
          <button className="close_btn" onClick={onClose}>
            <FaTimes />
          </button>

          <h3>Contact via Email</h3>
          <p>{popupMSG}</p>

          <a className="email_link" href="mailto:contact@example.com">
            contact@example.com
          </a>
        </div>
      </div>
    </>
  );
}
